<template>
  <div class="top-nvb_box">
    <div class="top-nvb flex flex-col sm:flex-row sm:justify-center items-center md:py-[12px] py-[14px]">
      <div class="logo-box h-[52px] md:h-[42px] flex">
        <router-link :to="brand?.url === '' ? '/' : `/${brand?.url}`" class="flex items-center">
          <img width="100%" class="img" :src="logoSrc" />
        </router-link>
      </div>
      <span class="lang" @click="toggleLang">{{ switchLangText }}</span>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/assets/js/event-bus'
export default {
  name: 'HeaderPage',
  props: {
    brand: { type: Object, default: () => ({}) },
  },
  computed: {
    logoSrc() {
      return this.brand?.name == ''
        ? require('@/assets/img/logo.png')
        : require(`@/assets/img/logo_${this.brand?.name}.png`)
    },
    switchLangText() {
      return this.$i18n.locale === 'zh' ? 'EN' : '中'
    },
  },
  methods: {
    toggleLang() {
      const newLocale = this.$i18n.locale === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = newLocale
      window.sessionStorage.setItem('sessionLang', newLocale)
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, lang: newLocale },
      })
      EventBus.$emit('message', newLocale)
    },
  },
}
</script>

<style lang="scss" scoped>
.img {
  // object-fit: cover;
  // height: 90%;
}

.top-nvb_box {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  border-bottom: #cccccc8c solid 1px;
  z-index: 1000;
  backdrop-filter: blur(10px);
  background-color: #fafafab3 !important;

  .top-nvb {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;

    .logo-box {
      width: 120px;
    }

    .lang {
      position: absolute;
      top: 50%;
      right: 15px;
      font-size: 14px;
      transform: translate(0%, -50%);
      cursor: pointer;
      border-bottom: 1px solid currentColor;
      padding-bottom: 1px;
    }
  }
}
</style>
